import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }
const _hoisted_5 = {
  key: 0,
  style: {"color":"#16b777"}
}
const _hoisted_6 = {
  key: 1,
  style: {"color":"#FF5722"}
}

import { ref, reactive } from 'vue'
  import { layer } from '@layui/layer-vue'
  import { allRunningDetails} from '../../api'
  
 
  
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

  const searchSelection = ref("")
  const loading = ref(false);
  
  const dataSource = ref([]);
  
  const selectedKeys = ref([]);
 
  const page = reactive({ current: 1, limit: 10, total: 0 });

  const search = reactive({
    key: searchSelection,
  })
  
  const columns = ref([
    
    { title: "余额", key: "beforeMod", align: "center"},
    { title: "收支", key: "incomeEexpen", align: "center", customSlot: "incomeEexpen"},  
    { title: "当前余额 ", key: "afterMod", align: "center"},  
    { title: "类型", key: "type", align: "center", customSlot: "type" },    
    { title: "时间", key: "addTime", align: "center" }, 
  ]);
  
  const getAllAdminUser = () => {
    loading.value = true;
    var data = { "page": page.current, "limit": page.limit, "key": search.key };
    allRunningDetails(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        dataSource.value = res.data;
        page.total = res.count;
      } else {
        dataSource.value = [];
        page.total = 0;
      }
    })
  }
  //获取数据
  getAllAdminUser();
  
  const change = (page: any) => {
    getAllAdminUser();
  }
  
  const sortChange = (key: any, sort: any) => {
    layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
  }
   
 
 
  
return (_ctx: any,_cache: any) => {
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_row = _resolveComponent("lay-row")!

  return (_openBlock(), _createBlock(_component_lay_row, { space: "10" }, {
    default: _withCtx(() => [
      _createVNode(_component_lay_col, { md: "24" }, {
        default: _withCtx(() => [
          _createVNode(_component_lay_panel, null, {
            default: _withCtx(() => [
              _createVNode(_component_lay_table, {
                page: page,
                height: '100%',
                columns: columns.value,
                loading: loading.value,
                "data-source": dataSource.value,
                "selected-keys": selectedKeys.value,
                "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((selectedKeys).value = $event)),
                onChange: change,
                onSortChange: sortChange
              }, {
                type: _withCtx(({ row }) => [
                  (row.type==1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, "充值分成"))
                    : (row.type==2)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "提现"))
                      : (row.type==3)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "用户退单"))
                        : (row.type==4)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "提现失败"))
                          : _createCommentVNode("", true)
                ]),
                incomeEexpen: _withCtx(({ row }) => [
                  (row.type==1||row.type==4)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, "+"))
                    : _createCommentVNode("", true),
                  (row.type==2||row.type==3)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, "-"))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(row.incomeEexpen), 1)
                ]),
                _: 1
              }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})